import { IPublicClientApplication } from '@azure/msal-browser';
import moment from 'moment';

export async function getToken(instance: IPublicClientApplication) {
    const user:any = instance.getAllAccounts()[0];
    const response = await instance.acquireTokenSilent({
        scopes: [],
        account: user
    });
    return response.idToken;    
}
export const getDateString = (date: Date) => {
    return moment(date).format("YYYY-MM-DD");
}
export const splitArray = (objArray: any, objNo: number): any => {
    return (
        objArray.reduce((resultArray: any, item: {}, index: number) => {
            const chunkIndex = Math.floor(index / objNo)

            if (!resultArray[chunkIndex]) {
                resultArray[chunkIndex] = [];
            }
            resultArray[chunkIndex].push(item)

            return resultArray
        }, [])
    );
}
export const ConvertToPounds = (value: number) => {
    return "£" + (value / 100).toFixed(2);
}

export const getDaysArray = function (start: string, end: string) {
    var startDate = start;
    var endDate = end;

    if (new Date(start) > new Date(end)) {
        startDate = end;
        endDate = start;
    }
    var startDateM = moment(startDate);
    var endDateM = moment(endDate);
    var now = startDateM.clone(), dates = [];

    while (now.isSameOrBefore(endDateM)) {
        dates.push(now.format('YYYY-MM-DD'));
        now.add(1, 'days');
    }
    return dates;
};

